import { forwardRef, ReactNode } from 'react';

import classNames from 'classnames';
import { Popover } from 'radix-ui';

export interface ComboboxTriggerProps {
  children?: ReactNode;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const ComboboxTrigger = forwardRef<HTMLDivElement, ComboboxTriggerProps>(
  ({ children, className, onClick, ...rest }, ref) => {
    return (
      <Popover.Trigger asChild>
        <div
          {...rest}
          ref={ref}
          role="button"
          tabIndex={0}
          className={classNames('cursor-pointer', className)}
          onClick={(e) => {
            onClick?.(e);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
            }
          }}
        >
          {children}
        </div>
      </Popover.Trigger>
    );
  }
);
